import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import Routes from "./app/route";
import "bootstrap/dist/css/bootstrap.css";
import WOW from "wowjs";
import "wowjs/css/libs/animate.css";
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import RootReducer from './redux';

const store = createStore(RootReducer , window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
// store.subscribe()

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      IsPaid: true,
    };
  }
  componentDidMount() {
    new WOW.WOW().init();
  }

  render = () => (
    <BrowserRouter>
      {this.state.IsPaid === null ? (
        <></>
      ) : !this.state.IsPaid ? (
        <>
          <h1 className="text-center mt-5">
            تا اطلاع ثانوی این سایت به دلیل پرداخت نشدن مبلغ قفل میباشد
          </h1>
        </>
      ) : (
        <Provider store={store}>
          <Switch>
            <Routes />
          </Switch>
        </Provider>
      )}
    </BrowserRouter>
  );
}

export default App;
